import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import _get from 'lodash/get'

import { get_brand, get_event } from '../../_common/core/selectors'
import { getTitle } from '../utils/getTitle'
import PaymentPlanSection from './payments/PaymentPlanSection/PaymentPlanSection'

const mapStateToProps = state => ({
  event: get_event(state),
  brand: get_brand(state),
  user: state.auth.user,
})

const EventPayments = props => {
  const { event, brand, user, configs } = props
  const { displayName } = event

  useEffect(() => {
    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])
  }, [configs, displayName])

  return (
    <>
      <PaymentPlanSection event={event} brand={brand} user={user} />
    </>
  )
}

export default connect(mapStateToProps)(EventPayments)
